import { safeSessionStorage } from '@zealot/shared/browser';

import { useAppStore } from '@/store';
import { restoreStandingSignOuts, standingSignOutKeys } from './brandSignOut';
import { clearMagicToken } from './magicToken';
import { clearResolverCache } from './tokenResolver';

// gloss
export const clearSessionState = () => {
  if (typeof window === 'undefined') return;

  const standing = standingSignOutKeys();

  window.localStorage.clear();
  window.sessionStorage.clear();

  restoreStandingSignOuts(standing);

  // why: must clear the zustand currentUser slice too — clearing the token alone leaves the
  // why: stale identity alive in memory.
  clearMagicToken();
  clearResolverCache();
  useAppStore.getState().currentUser.clear();
  useAppStore.getState().hubBrand.clear();
  useAppStore.getState().brandTheme.clear();
};

// gloss
export const markJustLoggedOut = (): void => {
  safeSessionStorage.setItem('just_logged_out', '1');
};

// gloss
export const readJustLoggedOutFlag = (): boolean => safeSessionStorage.getItem('just_logged_out') === '1';

// gloss
export const clearJustLoggedOutFlag = (): void => {
  safeSessionStorage.removeItem('just_logged_out');
};
